<template>
  <div>
    <label><b>% Expectativa mensal atingida</b></label>
    <b-progress :value="metaAtingida" :max="max" :variant="variant" show-progress class="mt-3"/>
  </div>
</template>
<script>
  export default {
    props: {
      pProgressMetasValues: {}
    },
    data () {
      return {
        variant: '',
        metaAtingida: 0,
        restante: 0,
        max: 100
      }
    },
    watch: {
      pProgressMetasValues: function (newVal, oldVal) { // watch it
        // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        let atingido = newVal.valorAtingido
        let meta = newVal.valorMeta

        if (meta > 0) {
          let metaAtingida = parseFloat(((atingido * 100) / meta)) // valor atingido em porcentagem do valor da meta
          let restante = (100 - metaAtingida) // 100 - porc de valor da meta
          this.restante = restante
          this.metaAtingida = metaAtingida
          if (metaAtingida < 32) {
            this.variant = 'danger'
          } else if (metaAtingida > 33 && metaAtingida < 66) {
            this.variant = 'warning'
          } else {
            this.variant = 'success'
          }
        } else {
          this.restante = 0.00
          this.metaAtingida = 0.00
        }
      }
    },
    mounted () {
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/items/ProgressMetasVue.vue